import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import formationsManagementStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsManagement'
const customImplement: CustomStoreImplementationOptions = formationsManagementStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsManagementFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-13-management.title', 'Formation en Management'),
        $description: $translate('prog-13-management.description', 'Matchers vous propose une formation en management sur-mesure et gratuite pour VOTRE entreprise, avec l\'accompagnement d\'un expert dans ce domaine !'),
        $publishedTime: new Date('2023-04-24T12:17:24.262Z'),
        $modifiedTime: new Date('2023-08-29T07:17:46.461Z'),
        // Constants,
        $constants: {
          blocPreviewProfilExpertTags: [
            { Nom: 'Accompagnement équipes' },
            { Nom: 'Animation réseau interne' },
            { Nom: 'Management' },
            { Nom: 'Esprit d\'équipe' },
            { Nom: ' Feedbacks clients' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element1Tags: [
            { Nom: 'Accompagnement équipes' },
            { Nom: 'Gestion de carrières' },
            { Nom: 'Gestion de conflits' },
            { Nom: 'Gestion des émotions' },
            { Nom: ' Gestion du stress' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element1Poste: '<p><span style="color:rgb(34,34,34);">Formatrice &amp; Intervenante</span></p>',
          element2Tags: [
            { Nom: 'Pizza' },
            { Nom: 'Shirt' },
            { Nom: 'Keyboard' },
            { Nom: 'Shirt' },
            { Nom: 'Table' },
            { Nom: 'Salad' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element3Tags: [
            { Nom: 'Pizza' },
            { Nom: 'Shirt' },
            { Nom: 'Keyboard' },
            { Nom: 'Shirt' },
            { Nom: 'Table' },
            { Nom: 'Salad' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          dropDownFormationArguments: [
            { Text: '<ul><li>Identifier son propre système de valeurs.</li></ul>' },
            { Text: '<ul><li>Appréhender ses talents de leader.</li></ul>' },
            { Text: '<ul><li>Comparer le manager et le leader.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Connaître son propre style de communication.</li></ul>' },
            { Text: '<ul><li>Identifier le style de communication de ses interlocuteurs.</li></ul>' },
            { Text: '<ul><li>Développer son éloquence.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Identifier les leviers de motivations pertinents.</li></ul>' },
            { Text: '<ul><li>Repérer les risques de démotivation.</li></ul>' },
            { Text: '<ul><li>Savoir déléguer des tâches responsabilisantes.</li></ul>' },
            { Text: '<ul><li>Identifier les points forts et les points faibles de ses collaborateurs.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element6Arguments: [
            { Text: '<ul><li>Adapter son comportement selon les situations.</li></ul>' },
            { Text: '<ul><li>Aborder les erreurs dans une dynamique positive.</li></ul>' },
            { Text: '<ul><li>Savoir faire preuve d’autorité.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          pFormationMatchingDescriptionCompany: '<p><span style="background-color:transparent;color:#000000;"><strong>Axeptio</strong></span> | Plateforme de gestion des consentements sur les sites web et applications mobiles.</p><p>&nbsp;</p><p>&nbsp;</p><p><strong>Besoin :&nbsp;</strong>Plusieurs personnes de l\'entreprise doivent savoir manager une équipe.</p>'
        },
        // Data,
        $info: { prog13Management: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      blocPreviewProfilExpertClick () {
        openUrl('https://www.matchers.fr/expert/246', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element1Click () {
        openUrl('https://www.matchers.fr/expert/639', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      voirClick () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsManagementFactory(storeId)()
}

export const formationsManagementRaw = formationsManagementFactory()
export const formationsManagement = () => formationsManagementRaw() as MergeCustomStore<typeof formationsManagementStoreCustom.instance>
